export default __webpack_public_path__ + "static/media/footerLeftPolygon.12d51d36.svg";